export default {
  date: 'March 07, 2025',
  title: 'Last Chance to Save: Get Your Floor Plans at Old Prices!',
  description: 'Limited-time offer – prices increase after march 11, 2025!',
  id: 'last-chance',
  jsx: () => (
    <div class='novelty__text'>
      <p>This March, you have a unique opportunity to purchase packages of 5 to 50 floor plans at old prices and top up your Getfloorplan account.</p>
      <p>What does this mean?</p>
      <p>You can choose any of our packages, including Plus, Render, Max, and others — for example, 15 units of the Basic package — and buy them at a discounted price.</p>
      <p>Benefits of this offer:</p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>Purchased packages are valid indefinitely, so you can use them at any time.</li>
        <li class='margin-none'>After topping up your account, you will receive a unique promo code to use when creating floor plans.</li>
      </ul>
      <p>Offer validity:</p>
      <p>This offer is available only until March 11, 2025!</p>
      <p>But hurry! This month, we are releasing a new update and increasing our prices. Take advantage of the current rates while they are still available!</p>
      <p>How to claim this offer:</p>
      <p>
        Email us at <a href='mailto:customerservice@getfloorplan.com'> customerservice@getfloorplan.com</a>, and our manager will assist you with the purchase process.
      </p>
      <p>Don't miss the opportunity to save! This special offer is valid only until March 11, 2025—secure your packages before the price increase!</p>
    </div>
  ),
  thumb: 'news/41.webp',
};
